import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string | JSX.Element;
}

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs: FAQItem[] = [
    {
      question: 'Do you offer mobile window tinting services in Baltimore?',
      answer: (
        <>
          Yes! We provide <a href="/mobile-tinting" className="text-teal-600 hover:text-teal-700 font-medium">mobile tinting services</a> throughout Baltimore and surrounding areas. We'll come to your home, office, or preferred location for your convenience.
        </>
      ),
    },
    {
      question: 'What types of window tinting do you offer in Baltimore?',
      answer: (
        <>
          We offer <a href="/window-tinting" className="text-teal-600 hover:text-teal-700 font-medium">premium ceramic tinting</a>, standard tinting, <a href="/commercial-tinting" className="text-teal-600 hover:text-teal-700 font-medium">commercial building tinting</a>, and specialty services like <a href="/headlight-taillight-tinting" className="text-teal-600 hover:text-teal-700 font-medium">headlight and taillight tinting</a>. All services come with a lifetime warranty.
        </>
      ),
    },
    {
      question: 'How long does window tinting take in Baltimore?',
      answer: 'Most vehicle tinting jobs take 2-4 hours depending on the size and type of vehicle. We offer same-day service for most appointments in the Baltimore area.',
    },
    {
      question: 'Is window tinting legal in Baltimore, Maryland?',
      answer: 'Yes, window tinting is legal in Maryland with specific regulations. Front side windows must allow more than 35% light transmission, and we ensure all our installations meet Maryland state laws.',
    },
    {
      question: 'Do you offer vehicle decals and wraps in Baltimore?',
      answer: (
        <>
          Absolutely! We provide professional <a href="/vehicle-decals" className="text-teal-600 hover:text-teal-700 font-medium">vehicle decals and custom graphics</a> for personal and commercial vehicles throughout Baltimore.
        </>
      ),
    },
    {
      question: 'What areas of Baltimore do you serve?',
      answer: 'We serve all of Baltimore including Downtown, Inner Harbor, Fells Point, Canton, Federal Hill, Mount Vernon, Hampden, and surrounding neighborhoods. We also service nearby areas like Towson, Owings Mills, and Glen Burnie.',
    },
    {
      question: 'Do you offer a warranty on window tinting in Baltimore?',
      answer: 'Yes! All our window tinting services come with a lifetime warranty covering peeling, bubbling, and discoloration. We stand behind our work 100%.',
    },
    {
      question: 'Can you tint commercial buildings in Baltimore?',
      answer: (
        <>
          Yes, we specialize in <a href="/commercial-tinting" className="text-teal-600 hover:text-teal-700 font-medium">commercial window tinting</a> for offices, storefronts, and buildings throughout Baltimore. Commercial tinting reduces energy costs and improves privacy.
        </>
      ),
    },
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 px-4 bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-600">
            Common questions about our window tinting services in Baltimore
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border border-gray-200 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-5 text-left bg-white hover:bg-gray-50 transition-colors flex items-center justify-between cursor-pointer"
              >
                <h3 className="text-lg font-semibold text-gray-900 pr-8">
                  {faq.question}
                </h3>
                <i
                  className={`ri-arrow-down-s-line text-2xl text-teal-600 transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 py-4 bg-gray-50 text-gray-700 leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-4">
            Still have questions? We're here to help!
          </p>
          <a
            href="/contact"
            className="inline-block px-8 py-3 bg-teal-600 text-white font-semibold rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            Contact Us
          </a>
        </div>
      </div>
    </section>
  );
}
